/* Plasmik3D — Popup d'annonce du délai de fabrication
   ==================================================================
   Tout est piloté par les attributs data- posés par la section : ce fichier
   ne contient aucun réglage, il est donc mis en cache par le navigateur au
   lieu d'être réinjecté dans le HTML de chaque page.

   La popup se ferme uniquement via son bouton : le but est que le visiteur
   confirme avoir lu le délai. Le focus est retenu à l'intérieur tant qu'elle
   est ouverte, mais le bouton reste toujours atteignable au clavier — il n'y
   a donc pas de piège au sens de WCAG 2.1.2.
   ================================================================== */
(function () {
  'use strict';

  var popup = document.querySelector('[data-delay-popup]');
  if (!popup) return;

  var closeButton = popup.querySelector('[data-delay-popup-close]');
  if (!closeButton) return;

  var storageKey = popup.dataset.storageKey;

  // Le mode navigation privée fait lever une exception au simple accès à
  // sessionStorage sur certains navigateurs : sans ce garde-fou, la popup
  // disparaîtrait purement et simplement pour ces visiteurs.
  function getStorage() {
    try {
      return popup.dataset.storageType === 'local' ? window.localStorage : window.sessionStorage;
    } catch (e) {
      return null;
    }
  }

  function alreadyAcknowledged() {
    var storage = getStorage();
    if (!storage) return false;
    try {
      return storage.getItem(storageKey) === '1';
    } catch (e) {
      return false;
    }
  }

  function remember() {
    var storage = getStorage();
    if (!storage) return;
    try {
      storage.setItem(storageKey, '1');
    } catch (e) {
      /* quota plein ou stockage refusé : on ferme quand même. */
    }
  }

  function close() {
    popup.classList.remove('is-visible');
    document.body.classList.remove('delay-popup-open');
    remember();
  }

  function open() {
    popup.classList.add('is-visible');
    document.body.classList.add('delay-popup-open');
    closeButton.focus({ preventScroll: true });
  }

  closeButton.addEventListener('click', close);

  popup.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    // Un seul élément focusable : on y ramène le focus au lieu de le laisser
    // partir derrière la popup.
    event.preventDefault();
    closeButton.focus();
  });

  if (!alreadyAcknowledged()) open();
})();
